import React, { useEffect, useState } from "react";
import { SelectInput, useInput } from "react-admin";

type Choice = {
  id: number;
  name: string;
};

type Props = {
  selectedId: number;
  choices: Choice[];
};

export const RelationalSelectInput = (props: Props) => {
  const { selectedId, choices, ...rest } = props;
  const { field } = useInput(props);
  const [helperText, setHelperText] = useState<string>(
    choices.length === 0 ? "選択できる項目がありません。" : "ui.offers.region_id_helper_text"
  );

  useEffect(() => {
    // 選択しているIDのものが選択肢になかったらリセットする
    const changed = choices.every((i) => i.id !== selectedId);
    if (changed && selectedId) {
      field.onChange(null);
    }
    setHelperText(choices.length === 0 ? "選択できる項目がありません。" : "ui.offers.region_id_helper_text");
  }, [choices, selectedId, field]);

  return (
    <SelectInput
      {...rest}
      choices={choices}
      helperText={helperText}
      FormHelperTextProps={{ sx: { minHeight: "24px" } }}
    />
  );
};
